import { Button } from '@mui/material';
import React from 'react';
import DoctorRequestPage from 'src/pages/DoctorRequestPage';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Paper } from '@material-ui/core';
import { userAtom } from 'src/atoms/user';
import { useRecoilValue } from 'recoil';
import AdminRequestPage from 'src/pages/AdminRequestPage';
function PreviousRequestPreview({ reqId, setShowGrid }) {
  const user = useRecoilValue(userAtom);
  return (
    <>
      <Button
        style={{ fontSize: 'large' }}
        onClick={() => {
          setShowGrid(true);
        }}
      >
        <ArrowBackIosIcon style={{ cursor: 'pointer' }} />
        Back
      </Button>
      <Paper style={{ overflowY: 'scroll', maxHeight: '100%' }}>
        {user.role === 'DOCTOR' ? (
          <DoctorRequestPage reqId={reqId} preview={true} />
        ) : (
          <AdminRequestPage preview={true} reqId={reqId} />
        )}
      </Paper>
    </>
  );
}

export default PreviousRequestPreview;
